import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Slider from 'react-slick'

import { trackEventLog } from '../../../core/utils'
import s from './index.css';
import CourseCard from '../../common/CourseCard'

import IconLeftNav from './ic_left.png'
import IconRightNav from './ic_right.png'

const slideSetting = {
  dots: true,
  infinite: false,
  speed: 500,
  // autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <div {...this.props} />,
  nextArrow: <div {...this.props} />,
}


const slickDotsStyle = `
  .slick-list {
  }
  .slick-dots button {
    display: none;
  }
  .slick-dots{
    position:absolute;
    height: 2px;
    top: 260px;
    left: -290px;
    width: 280px;
    text-align: center;
  }
  .slick-dots li{
    display: inline-block;
    height: 2px;
    width: 30px;
    background: rgba(255, 255, 255, 0.5);
    line-height: 2px;
    vertical-align: top;
    margin: 0 2px;
    border-radius: 2px;
  }
  .slick-dots .slick-active {
    background: #fff;
  }
  .tag-slide .slick-arrow {
    position: absolute;
    top: 110px;
    height: 60px;
    width: 36px;
    background: rgba(0, 0, 0, 0.1);
    z-index: 10;
    display: none !important;
    cursor: pointer;
  }
  .tag-slide .slick-slider:hover .slick-arrow {
    display: block !important;
  }
  .tag-slide .slick-prev {
    left: 10px;
    background: rgba(0, 0, 0, 0.1) url(${IconLeftNav}) center center no-repeat;
  }
  .tag-slide .slick-arrow:hover {
    background: rgba(0, 0, 0, 0.3) url(${IconLeftNav}) center center no-repeat;
  }
  .tag-slide .slick-next {
    right: 10px;
    background: rgba(0, 0, 0, 0.1) url(${IconRightNav}) center center no-repeat;
  }
  .tag-slide .slick-next:hover {
    background: rgba(0, 0, 0, 0.3) url(${IconRightNav}) center center no-repeat;
  }
  .tag-slide .slick-prev.slick-disabled {
    background: rgba(0, 0, 0, 0.05) url(${IconLeftNav}) center center no-repeat;    
  }
  .tag-slide .slick-next.slick-disabled {
    background: rgba(0, 0, 0, 0.05) url(${IconRightNav}) center center no-repeat;    
  }
`

class Column extends React.Component {

  static calcCurBg(inx) {
    switch (inx % 3) {
      case 0:
        return s.bg1;
      case 1:
        return s.bg2;
      case 2:
        return s.bg3;
      default:
        return s.bg1
    }
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    inx: PropTypes.number.isRequired,
    tagId: PropTypes.number.isRequired,
  }
  renderCourseCard(course, idx, isLimit, inx) {
    const { tagId } = this.props
    return (course.itemType === 3 ?
      <CourseCard
        inLoc={'vertical'}
        onClick={() => trackEventLog('xue_click', { unit: 'courseGroup', type: 'vertical', position: idx + 1, resource_id: course.id })}
        showLogFuc={() => trackEventLog('xue_show', { unit: 'courseGroup', type: 'vertical', position: idx + 1, resource_id: course.id })}
        key={`serial-course2-${course.id}`}
        className={s.courseCard}
        serialCourse={course}
        data={{}}
      /> :
      <CourseCard
        key={`tag_column_course_${course.id}`}
        inLoc={`vp_pro_tag${tagId}`}
        data={course}
        onClick={() => { trackEventLog(`w/tag/${tagId}/promotion/${isLimit ? idx : (inx * 3) + idx}`) }}
      />)
  }
  render() {
    const { data, inx } = this.props
    const limitedData = data.courseCards
    const slideCount = Math.ceil(limitedData.length / 3)
    const slides = []
    for (let i = 0; i < slideCount; i++) {
      slides[i] = limitedData.slice(3 * i, (i * 3) + 3)
    }
    return (
      <div className={'tag-slide'}>
        <style dangerouslySetInnerHTML={{ __html: slickDotsStyle.replace(/\t|\s{2,}/gi, '') }} />
        <div className={`${s.title} ${Column.calcCurBg(inx)}`}>
          <div className={s.titleContent}>{data.title}</div>
        </div>
        <div className={s.content}>
          {slideCount > 1 ?
            <Slider {...slideSetting}>
              {slides.map((slide, inx1) => (
                <div
                  key={`tag_column_slide_${inx1}`}
                  className={s.slideCard}
                >{slide.map((course, idx) =>
                  // 兼容系列课卡片
                  this.renderCourseCard(course, idx, false, inx1))}</div>
                ))}
            </Slider> :
            <div className={s.slideCard}>
              {limitedData &&
                limitedData.map((course, inx2) => this.renderCourseCard(course, inx2, true))
              }
            </div>
          }

        </div>
      </div>
    );
  }
}

export default withStyles(s)(Column)



// WEBPACK FOOTER //
// ./src/components/p_tag/Column/index.js